import { createClient } from '@supabase/supabase-js';

// 只通过环境变量读取 Supabase 配置
const supabaseUrl = 'https://dmmazfzfnulkgzqaxhml.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRtbWF6ZnpmbnVsa2d6cWF4aG1sIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE4NDk0MDcsImV4cCI6MjA2NzQyNTQwN30.JRczHGnDkd_iEpwqaNiO4XVlbCJo-lWVnQz2Ni12YRs';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
